
import "./Header.css"
import Btn from "../Btn/Btn"
import "../img/child-swimming-in-pool_70ec5dc15b0cc256b31d1009d5badbbc.jpg"
import Contact from "../contact/Contact"
export default function Header({submit}){
    
    return(
        <div>
            <section className="hero">
                <div className="hero-content">
                <h1>مربی شنا در تبریزآموزش حرفه‌ای برای کودکان و بزرگسالان</h1>
                <p>کلاس‌های خصوصی و گروهی آموزش شنا در تبریز با متد اصولی و ایمن</p>
                <Contact>
                <Btn title=" ثبت نام در کلاس شنا"/>
                </Contact>
                </div>
            </section>
            <Contact/>
            {/* <h1> {props.element.title}</h1>
            <h3>{props.element.teacher}</h3>
            <h4>{props.element.hours}</h4> */}
           {/* <form onSubmit={submit}>
                <input type="text" placeholder="type..."/>
                <button>click</button>
            </form> */}
        </div>
    )
}